import FormFields from './FormFields';
import OverviewSection from './OverviewSection';
import ReservationData from './ReservationData';
import { calculatePrice } from './utils';

// Logic extracted from Calendar.js
const getReservationLabel = (reservation) => {
    let canoeCount = 0;
    if (reservation.kanoe_count > 0) {
        canoeCount = reservation.kanoe_count;
    } else if (reservation.kanoe_count_info_min === reservation.kanoe_count_info_max) {
        canoeCount = reservation.kanoe_count_info_min;
    } else {
        canoeCount = `${reservation.kanoe_count_info_min} - ${reservation.kanoe_count_info_max}`;
    }

    let katCount = reservation.katamaran_count_info ? `(${reservation.katamaran_count_info}kat)` : '';

    let clientText = reservation.client?.name ?
        reservation.client.name :
        reservation.client?.phone ?
            reservation.client.phone :
            reservation.client?.email;

    return `${canoeCount}ks ${katCount} ${clientText}`;
};

const getDayHeaderStats = (reservations) => {
    let kanoeCount = 0;
    let katCount = 0;

    reservations.forEach(reservation => {
        if (reservation && reservation.status !== 'canceled') {
            kanoeCount += (parseInt(reservation.kanoe_count_info_max) || 0);
            katCount += (parseInt(reservation.katamaran_count_info) || 0);
        }
    });

    return {
        primary: `${kanoeCount}ks`,
        secondary: katCount > 0 ? `(${katCount}kat)` : null
    };
};

export {
    FormFields,
    OverviewSection,
    ReservationData,
    calculatePrice,
    getReservationLabel,
    getDayHeaderStats
};

export const defaults = {
    kanoe_count_info_min: 0,
    kanoe_count_info_max: 0,
    katamaran_count_info: 0,
    kanoe_count: 0,
    katamaran_count: 0,
    vest_count: 0,
    paddle_count: 0,
    barrel_count: 0,
    note: ""
};
